import { useStore } from "@/model/store";

/** Whether you follow a node (`PUT` / `DELETE /nodes/:h/follow`), and a toggle. Followed nodes lead Home. */
export function useFollow(nodeId: string): [boolean, () => void] {
	const followed = useStore((s) => s.follows.includes(nodeId));
	const toggle = useStore((s) => s.toggleFollow);
	return [followed, () => toggle(nodeId)];
}
